"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbNotificationsDropDown = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../sb-inline-messages/utils");

var _isClickOutside = require("../../skybase-core/utils/is-click-outside");

var _sbNotifications = require("./sb-notifications");

var _shapes = require("./shapes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NOOP = function NOOP() {};

var getAlertIconColorClassName = function getAlertIconColorClassName(notifications) {
  if ((0, _utils.hasError)(notifications)) {
    return 'color-error';
  }

  if ((0, _utils.hasWarning)(notifications)) {
    return 'color-warning';
  }

  return null;
};

var SbNotificationsDropDown = /*#__PURE__*/function (_Component) {
  _inherits(SbNotificationsDropDown, _Component);

  var _super = _createSuper(SbNotificationsDropDown);

  function SbNotificationsDropDown(props) {
    var _this;

    _classCallCheck(this, SbNotificationsDropDown);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleClickOutside", function (event) {
      var expanded = _this.state.expanded;
      var ignoreClasses = ['sb-modal-container', 'sb-modal', 'sb-modal-overlay'];

      if (expanded && (0, _isClickOutside.isClickOutside)(event, _this.node, ignoreClasses)) {
        _this.toggleDropDown(false);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDropDown", function (expanded) {
      return _this.setState({
        expanded: expanded
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnAllAlarmsAndWarningsClick", function () {
      var onAllAlarmsAndWarningsClick = _this.props.onAllAlarmsAndWarningsClick;

      _this.toggleDropDown(false);

      if (onAllAlarmsAndWarningsClick) {
        onAllAlarmsAndWarningsClick();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnNotificationClick", function (notification) {
      var onNotificationClick = _this.props.onNotificationClick;

      _this.toggleDropDown(false);

      if (onNotificationClick) {
        onNotificationClick(notification);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnRemoveNotificationClick", function (notification) {
      var onRemoveNotificationClick = _this.props.onRemoveNotificationClick;

      if (onRemoveNotificationClick) {
        onRemoveNotificationClick(notification);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnClick", function () {
      _this.setState(function (prevState) {
        return {
          expanded: !prevState.expanded
        };
      });
    });

    _this.state = {
      expanded: false
    };
    return _this;
  }

  _createClass(SbNotificationsDropDown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('click', this.handleClickOutside);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          dropDownButtonClassName = _this$props.dropDownButtonClassName,
          dropDownButtonId = _this$props.dropDownButtonId,
          id = _this$props.id,
          notifications = _this$props.notifications,
          listContainerClassName = _this$props.listContainerClassName,
          listContainerId = _this$props.listContainerId,
          alarmsAndWarningsLimit = _this$props.alarmsAndWarningsLimit,
          relativeDateTime = _this$props.relativeDateTime,
          summaryId = _this$props.summaryId,
          renderAllItemsButton = _this$props.renderAllItemsButton;
      var expanded = this.state.expanded;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('sb-position-relative', 'sb-notifications-container', className),
        id: id,
        ref: function ref(node) {
          _this2.node = node;
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('sb-status-bar-btn', 'fl-container', 'fl-center-center', dropDownButtonClassName),
        id: dropDownButtonId,
        type: "button",
        onClick: this.handleOnClick
      }, /*#__PURE__*/_react.default.createElement("i", {
        className: (0, _classnames.default)('sbi-alert', 'sb-margin-right-5px', getAlertIconColorClassName(notifications))
      }), /*#__PURE__*/_react.default.createElement("i", {
        className: (0, _classnames.default)({
          'sbi-chevron-up': expanded,
          'sbi-chevron-down': !expanded
        }, 'toggle-icon')
      })), /*#__PURE__*/_react.default.createElement(_sbNotifications.SbNotifications, {
        className: listContainerClassName,
        id: listContainerId,
        expanded: expanded,
        notifications: notifications,
        onNotificationClick: this.handleOnNotificationClick,
        onRemoveNotificationClick: this.handleOnRemoveNotificationClick,
        onAllAlarmsAndWarningsClick: this.handleOnAllAlarmsAndWarningsClick,
        alarmsAndWarningsLimit: alarmsAndWarningsLimit,
        relativeDateTime: relativeDateTime,
        summaryId: summaryId,
        renderAllItemsButton: renderAllItemsButton
      }));
    }
  }]);

  return SbNotificationsDropDown;
}(_react.Component);

exports.SbNotificationsDropDown = SbNotificationsDropDown;

_defineProperty(SbNotificationsDropDown, "propTypes", {
  className: _propTypes.default.string,
  dropDownButtonClassName: _propTypes.default.string,
  dropDownButtonId: _propTypes.default.string,
  id: _propTypes.default.string,
  summaryId: _propTypes.default.string,
  listContainerClassName: _propTypes.default.string,
  listContainerId: _propTypes.default.string,
  notifications: _propTypes.default.arrayOf(_shapes.notificationShape),
  onNotificationClick: _propTypes.default.func,
  onRemoveNotificationClick: _propTypes.default.func,
  onAllAlarmsAndWarningsClick: _propTypes.default.func,
  relativeDateTime: _propTypes.default.bool,
  alarmsAndWarningsLimit: _propTypes.default.number,
  renderAllItemsButton: _propTypes.default.bool
});

_defineProperty(SbNotificationsDropDown, "defaultProps", {
  className: null,
  dropDownButtonClassName: null,
  dropDownButtonId: null,
  id: null,
  listContainerClassName: null,
  listContainerId: null,
  notifications: [],
  onNotificationClick: NOOP,
  onRemoveNotificationClick: NOOP,
  onAllAlarmsAndWarningsClick: NOOP,
  relativeDateTime: false,
  alarmsAndWarningsLimit: 10,
  summaryId: null,
  renderAllItemsButton: true
});
//# sourceMappingURL=sb-notifications-drop-down.js.map